var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.CustomFields.length > 0
    ? _c(
        "div",
        { ref: "customFieldCheck" },
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
              _c("b-col", { attrs: { md: "12" } }, [
                _c("h3", [_vm._v("Additional Details")]),
              ]),
            ],
            1
          ),
          _c(
            "b-form",
            { on: { change: _vm.fieldChanges } },
            [
              _c(
                "b-row",
                { ref: "additionalFields" },
                _vm._l(_vm.CustomFields, function (item, index) {
                  return _c(
                    "b-col",
                    {
                      key: item.ordering,
                      attrs: { md: "12", id: item.ordering },
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: item.fieldName,
                            "label-for": "fieldname",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "fieldname",
                              type: item.fieldType,
                              placeholder: item.fieldName,
                              readonly: _vm.ReadOnlyFields,
                              disabled: _vm.ReadOnlyFields,
                            },
                            model: {
                              value: item.fieldValue,
                              callback: function ($$v) {
                                _vm.$set(item, "fieldValue", $$v)
                              },
                              expression: "item.fieldValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }